import '@packages/components/messagebox/messagebox.less';
import Utils from '@packages/utils/utils.js';
import EventBus from '@packages/utils/eventBus.js';
import Extends from '@packages/utils/extends.js';
import SMSTpl from './messagebox-sms.html'

var MessageBox = function (html, options) {
  var defaults = {
    title: null,
    message: null,
    buttons: []
  }
  this.options = defaults;
  Extends(this.options, options);
  this.unique = this.options.unique || Utils.getUnique();
  this.html = html;
  this._init();
}
MessageBox.prototype = {
  _init: function () {
    var self = this;
    self.observer = EventBus.create(self.unique);
    self._appendBody(self.html);
    self._addEvent();
  },
  _createElement: function (html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div;
  },
  _appendBody: function (html) {
    var self = this;
    self.$el = self._createElement(html);
    document.body.appendChild(self.$el);
  },
  _addEvent: function () {
    var self = this;
    var buttons = self.options.buttons;
    var $dom = null;
    for (var i = 0; i < buttons.length; i++) {
      $dom = self.$el.querySelector(buttons[i].el);
      if ($dom) {
        (function (index, _self) {
          $dom.addEventListener('click', function () {
            buttons[index].callback && buttons[index].callback.apply(_self, Array.prototype.slice.call(arguments));
            buttons[index].close && self.close();
          }, false)
        })(i, self);
      }
    }
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self)
        }
      }
    }
  },
  close: function () {
    var self = this;
    document.body.removeChild(self.$el);
  }
}

MessageBox.SMS = function (options) {
  var defaults = {
    title: '短信验证码',
    placeholder: '请输入短信验证码',
    maxLength: 6,
    counter: 10,
    onSend: Utils.noop,
    onInput: Utils.noop,
    onCancel: Utils.noop,
    onSubmit: Utils.noop
  };
  var config = {};
  config = Extends(defaults, options);
  config.buttons = [];
  config.buttons.push({
    el: '.js-btn-sms',
    callback: function () {
      this.observer.emit('onSend');
      startTimer(this.$el);
    }
  });
  config.buttons.push({
    el: '.js-btn-cancel',
    close: true,
    callback: function () {
      this.observer.emit('onCancel');
    }
  });
  config.buttons.push({
    el: '.js-btn-submit',
    callback: function () {
      this.observer.emit('onSubmit');
    }
  });
  var instance = new MessageBox(SMSTpl, config);
  var $input = instance.$el.querySelector('.bx-sms-input');
  instance.$el.querySelector('.bx-modal-title').innerText = config.title;
  $input.setAttribute('placeholder', config.placeholder);
  $input.setAttribute('maxlength', config.maxLength);
  instance.$el.querySelector('.bx-sms-count').innerText = config.counter;
  $input.addEventListener('input', function () {
    var value = instance.$el.querySelector('.bx-sms-input').value;
    instance.observer.emit('onInput', value);
    if (value === '') {
      Utils.removeClass($input, 'bx-sms-input--error');
    }
  });
  instance.setWrong = function () {
    Utils.addClass($input, 'bx-sms-input--error');
  }
  return instance;
}

var startTimer = function (el) {
  var $btnSMS = el.querySelector('.js-btn-sms');
  var $btnSMSDisable = el.querySelector('.bx-sms-btn--disable');
  var $smsCount = el.querySelector('.bx-sms-count');
  $btnSMS.style.display = 'none';
  $btnSMSDisable.style.display = 'block';
  var counter = $smsCount.innerText;
  var originalCounter = counter;
  counter = parseInt(counter);
  var timer = window.setInterval(function () {
    counter--;
    $smsCount.innerText = counter;
    if (counter === 0) {
      window.clearInterval(timer);
      timer = null;
      $smsCount.innerText = originalCounter;
      $btnSMS.innerText = '重新获取';
      $btnSMS.style.display = 'block';
      $btnSMSDisable.style.display = 'none';
    }
  }, 1000);
}

export default MessageBox;



// WEBPACK FOOTER //
// ./packages/components/messagebox/messagebox.js